import SearchBar from "../../components/universal/SearchBar";
import Navbar from "../../components/universal/Navbar";
import { useState,useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AddChurch from '../../screens/Ministry/AddMinistry'
import { Link } from "react-router-dom";
function AddField() {
  const tabs = [
  "Churches"];
  const [activeTab, setActiveTab] = useState(tabs[0]);
   const { userInfo, accessToken } = useSelector((state) => state.user);
   const [startIndex, setStartIndex] = useState(0);
   const location = useLocation(); // ✅ Add this line


   const { church, ministry } = location.state || {};
   const [selectedMinistryName, setSelectedMinistryName] = useState(() => {
     try {
       const saved = JSON.parse(localStorage.getItem("ministry") || "null");
       return (
         saved?.ministryName ||
         saved?.churchName ||
         saved?.name ||
         ""
       );
     } catch {
       return "";
     }
   });
   useEffect(() => {
     const onStorage = (e) => {
       if (e.key === "ministry") {
         try {
           const next = JSON.parse(e.newValue || "null");
           setSelectedMinistryName(
             next?.ministryName ||
               next?.churchName ||
               next?.name ||
               ""
           );
         } catch {
           setSelectedMinistryName("");
         }
       }
     };
     const onMinistryChange = (e) => {
       setSelectedMinistryName(
         e?.detail?.ministryName ||
           e?.detail?.churchName ||
           e?.detail?.name ||
           ""
       );
     };
     window.addEventListener("storage", onStorage);
     window.addEventListener("ministry:change", onMinistryChange);
     return () => {
       window.removeEventListener("storage", onStorage);
       window.removeEventListener("ministry:change", onMinistryChange);
     };
   }, []);

   const ministryTitle =
     ministry?.ministryName ||
     ministry?.churchName ||
     ministry?.name ||
     church?.ministryName ||
     church?.churchName ||
     church?.name ||
     selectedMinistryName ||
     "Ministry";
   const maxVisible = 9  ;

  useEffect(() => {
    const activeIndex = tabs.indexOf(activeTab);
    if (activeIndex < startIndex) {
      setStartIndex(activeIndex);
    } else if (activeIndex >= startIndex + maxVisible) {
      setStartIndex(activeIndex - maxVisible + 1);
    }
  }, [activeTab]);

  return (
    <div className="App bg-[#191919] h-fit min-h-screen w-full overflow-x-hidden flex p-4">
      <Navbar />
      <div className={`min-w-0 flex-1 ${userInfo.roleCode!='17dwer8'?'md:pl-32':''} md:pt-0 pt-20`}>
        <div className="flex min-w-0 flex-col gap-4 h-full">
          <SearchBar placeholder={"Search"} />



          <div className="flex min-w-0 items-center justify-between gap-4">
            <div className="min-w-0 truncate text-white text-2xl md:text-3xl font-semibold">
              {ministryTitle}
            </div>
            <Link
              to={"/ministry/all"}
              onClick={() => {
                const church = localStorage.getItem("church");
                if (church) {
                  localStorage.removeItem("church");
                }
              }}
            >
              <button className=" text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                See All Ministries
              </button>
            </Link>
          </div>


          <div className="MAIN-CONTENT flex min-w-0 h-full gap-4 text-white">


            {activeTab === "Churches" && (
              <>
                <div className="w-full min-w-0">
                  <AddChurch church={church} />
                </div>

              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default AddField;
